
export const truncateCopy = (copy: string, characterLimit: number, addElipsis?: boolean) => copy.length > characterLimit ? `${copy.substring(0, characterLimit)}${addElipsis ? '...' : ''}`: copy;
 